import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import HeaderAzul from '~/Components/HeaderAzul/HeaderAzul';
import qs from 'qs';

import Loading from '~/Components/Loading';
import Widget from '~/Components/Lancamento/Encaminhamento/PreEncaminhamento/widget';
import SenhaGrid from '~/Components/Lancamento/Encaminhamento/PreEncaminhamento/senhagrid';
import {
    fetchPreEncaminhamento,
    chamarProximaSenha,
    recallSenha,
    toggleSenha,
    atualizarPainelPre,
} from '~/Store/Lancamento/Encaminhamento/actions';

class PreEncaminhamento extends Component {
    state = {
        codigoFamilia: null,
        senhaRechamada: null,
    };

    refreshInterval = null;

    componentDidMount() {
        const { location } = this.props;
        const params = qs.parse(location.search, { ignoreQueryPrefix: true });
        const codigoFamilia = parseInt(params.familia, 10);

        if (codigoFamilia) {
            this.setState({ codigoFamilia }, () => {
                this.carregarDados();
                this.iniciarAutoRefresh();
            });
        }
    }

    componentWillUnmount() {
        this.pararAutoRefresh();
    }

    carregarDados = () => {
        const { codigoFamilia } = this.state;
        if (codigoFamilia) {
            this.props.fetchPreEncaminhamento(codigoFamilia);
        }
    };

    iniciarAutoRefresh = () => {
        this.refreshInterval = setInterval(this.carregarDados, 30000);
    };

    pararAutoRefresh = () => {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    };

    handleChamarProxima = () => {
        const { codigoFamilia } = this.state;
        this.props.chamarProximaSenha(codigoFamilia);
    };

    handleRecall = codigoSenha => {
        const { codigoFamilia } = this.state;
        this.props.recallSenha(codigoSenha, codigoFamilia);
        this.setState({ senhaRechamada: codigoSenha });
        clearTimeout(this.recallTimeout);
        this.recallTimeout = setTimeout(() => {
            this.setState({ senhaRechamada: null });
        }, 5000);
    };

    handleToggle = codigoSenha => {
        const { codigoFamilia } = this.state;
        this.props.toggleSenha(codigoSenha, codigoFamilia);
    };

    handleAtualizarPainel = () => {
        const { codigoFamilia } = this.state;
        this.props.atualizarPainelPre(codigoFamilia);
    };

    render() {
        const { relatorio, senhas, isLoading } = this.props;
        const { codigoFamilia } = this.state;

        if (!codigoFamilia) {
            return (
                <Container className="py-4">
                    <div className="alert alert-warning">
                        Nenhum empreendimento selecionado. Adicione <strong>?familia=CODIGO</strong> na URL.
                    </div>
                </Container>
            );
        }

        return (
            <Container fluid className="p-4">
                <HeaderAzul
                        title="Pré-Encaminhamento"
                        contemPesquisa={false}
                />
                <Row className="mb-2">
                    <Col md={4}>
                        <Widget
                            icon="fa-bullhorn"
                            title="Senhas Chamadas"
                            value={relatorio.numeroSenhas}
                            type="info"
                        />
                    </Col>
                    <Col md={4}>
                        <Widget
                            icon="fa-user"
                            title="Pessoas Encaminhadas"
                            value={relatorio.pessoasAtendidas}
                            type="success"
                        />
                    </Col>
                    <Col md={4}>
                        <Widget
                            icon="fa-desktop"
                            title="Posições disponíveis"
                            value={relatorio.posicoesDisponiveis}
                            type="info"
                        />
                    </Col>
                </Row>

                <Row className="mb-2">
                    <Col md={4} className="mx-auto">
                        <Button
                            variant="success"
                            size="lg"
                            block
                            onClick={this.handleChamarProxima}
                            className="font-weight-bold text-uppercase py-3"
                            style={{ fontSize: '1.2rem' }}
                        >
                            Chamar Próxima Senha
                        </Button>
                        <Button
                            variant="outline-primary"
                            size="sm"
                            block
                            onClick={this.handleAtualizarPainel}
                            className="mt-2"
                        >
                            <i className="fa fa-refresh mr-1" /> Atualizar Painel
                        </Button>
                    </Col>
                </Row>

                <Row>
                    <Col md={8} className="mx-auto">
                        {isLoading && senhas.length === 0 ? (
                            <Loading />
                        ) : (
                            <SenhaGrid
                                senhas={senhas}
                                onRecall={this.handleRecall}
                                onToggle={this.handleToggle}
                                senhaRechamada={this.state.senhaRechamada}
                            />
                        )}
                    </Col>
                </Row>
            </Container>
        );
    }
}

const mapStateToProps = state => ({
    relatorio: state.encaminhamento.preEncaminhamento.relatorio,
    senhas: state.encaminhamento.preEncaminhamento.senhas,
    isLoading: state.encaminhamento.preEncaminhamento.isLoading,
    isError: state.encaminhamento.preEncaminhamento.isError,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchPreEncaminhamento,
            chamarProximaSenha,
            recallSenha,
            toggleSenha,
            atualizarPainelPre,
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(PreEncaminhamento));